
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Switch,
    FormControl,
    FormLabel,
    FormControlLabel,
    Dialog,
    DialogTitle,
    Divider,
    Slide,
    InputLabel,
    Select,
    Grid,
    Button,
    DialogActions,
    LinearProgress
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutTabModel,
        LayoutSectionModel,
        LayoutFieldModel,
        LookupFieldModel,
        ObjectModel,
        RecordModel,
        RecordFactory,
        ActionModel,
        FieldMetadataModel,
        LayoutFieldFactory,
        LayoutSectionFactory,
        LayoutRelatedListModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {LayoutSectionComponent} from "../../components/layoutSection/LayoutSection";
import {CalendarDialogComponent} from "../../components/calendarDialog/CalendarDialog";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router";
import {setSelectedTabObject,
        getSelectedTabObject} from "../../app/globalLayoutSlice";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getAppName, getObjectName, getRecordUuid } from "../../utils/helperRouter";
import {EmailFieldComponent} from "../fields/EmailField";
import {UrlFieldComponent} from "../fields/UrlField";
import {UUIDFieldComponent} from "../fields/UUIDField";
import {BigAutoFieldComponent} from "../fields/BigAutoField";
import {AutoIdentifierNameFieldComponent} from "../fields/AutoIdentifierNameField";
import {TextFieldComponent} from "../fields/TextField";
import {JsonFieldComponent} from "../fields/JsonField";
import {FileFieldComponent} from "../fields/FileField";
import {TextFieldEncryptedComponent} from "../fields/TextFieldEncrypted";
import {DecimalFieldComponent} from "../fields/DecimalField";
import {BooleanFieldComponent} from "../fields/BooleanField";
import {SelectFieldComponent} from "../fields/SelectField";
import {DateFieldComponent} from "../fields/DateField";
import {DateTimeFieldComponent} from "../fields/DateTimeField";
import {LookupFieldComponent} from "../fields/LookupField";
import {useSnackbar} from "notistack";

//SHIFT THIS AT SOME POINT TO OTHER ROUTINE
import { useAuth } from "../../hooks/useAuth";
import {downloadFile as downloadFileApi} from "../../screens/record/recordSlice";
import {getFieldError} from '../../utils/fieldValidations';
import Config from "../../config";
/*

COMPONENT FOR DISPLAYING RECORD FROM A SELECTED TAB

*/

export const ShareComponent: React.FC<{
  data: any,
  action: ActionModel
}> = ({
  data,
  action
}) => {

  const styles = ContainerClasses();

  const dispatch = useDispatch<any>();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const [mutableRecord, setMutableRecord] = useState<RecordModel | null>(null);
  const [layoutSection, setLayoutSection] = useState<LayoutSectionModel | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if(data?.layout_section){
      const layoutSectionFactory = new LayoutSectionFactory()
      setLayoutSection(data.layout_section);

      //all fields on layout
      const fieldMetadata: FieldMetadataModel[] = [];
      const thisFields = data.layout_section.layout_fields.map((thisField: any) => {
                            fieldMetadata.push(thisField.ReferencedField_sys);
                          })
      const record = new RecordFactory().initFromMetadata(fieldMetadata, null)
      setMutableRecord(record)
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if(errorMessage){
     enqueueSnackbar(errorMessage, {
          variant: "error",
       });
    }
  }, [errorMessage]);

  useEffect(() => {
    if(successMessage){
     enqueueSnackbar(successMessage, {
          variant: "success",
       });
    }
  }, [successMessage]);




  const saveData = async (newRecord: RecordModel | null,
                          authToken: string) => {
      if(newRecord === null){
        return
      }

      if(layoutSection === null){
        return
      }

      const allErrors = layoutSection.layout_fields.map((thisLayoutField) => {
          //check all fields in this section for errors
          const fieldApiName = thisLayoutField.ReferencedField_sys.ApiName_sys;
          const thisField = newRecord?.fields[fieldApiName];
          const thisError = getFieldError(thisField, thisLayoutField);
          return thisError
        })
      const thisError = allErrors.includes(true);

      if(thisError === true){
        enqueueSnackbar("Error: some required fields are not defined", {
            variant: "error",
        });
        return
      }

    const actionUuid = action.Uuid_sys;
    const thisRecordUuid = getRecordUuid(recordUuid)
    const thisObjectApiName = getObjectName(objectName)


    try {



    //get object information for the selected lookup
    let url = `${Config.getInstance().getCoordinationServiceURL()}/api/f/action/${actionUuid}/${thisObjectApiName}/${thisRecordUuid}`;
    const headers = new Headers();

    headers.append("Authorization", `Bearer ${authToken}`);
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");

    const requestBody = new RecordFactory().toJSON(newRecord);


    const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestBody)
      })

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          setErrorMessage("Error when saving record");
        } else{
          setErrorMessage(errorData.message);
        }
        return;
      }

      const data = await response.json();

      if(!data ||
         !data.permission ||
         !data.assignment){
          setErrorMessage("Error when saving record");
          return;
      }

      setSuccessMessage("Sharing record created.")


    } catch (error){
       setErrorMessage("Unhandled error occurred, please contact your system administrator")
    }
  }






   return (
     <Box>
        {layoutSection !== null &&
         mutableRecord !== null &&

         <>

         <LayoutSectionComponent
            layoutSection={layoutSection}
            record={mutableRecord}
            onChange={() => {}}
          />

          <DialogActions>

          <Button
            color="primary"
            variant="contained"
            style={{ marginLeft: 20, marginTop: 5, marginBottom: 5 }}
            onClick={() => {
              saveData(mutableRecord, accessToken)
             }
            }
          >
            Save
          </Button>
          </DialogActions>

        </>
        }
       </Box>
     )

/*
  return (

<>

   <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
             <Typography>
                    {layoutSection.Label_sys}
                 </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Grid container spacing={2}>
                 {layoutSection.layout_fields.map((layout_field) => {

                   if(layout_field.ReferencedField_sys.Type_sys === 'CharField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return textFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'TextField' &&
                      layout_field.ReferencedField_sys.PicklistValues_sys === null){
                     return textFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'CharField'){
                     return selectFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'BooleanField'){
                    return booleanFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DateField'){
                    return dateFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DateTimeField'){
                    return dateTimeFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'SlugField'){
                    return (<Box>TODO: SlugField </Box>)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'TextField'){
                    return (<Box>TODO: TextField </Box>)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'JSONField'){
                    return jsonFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'IntegerField'){
                    return (<Box>TODO: IntegerField </Box>)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'URLField'){
                    return (urlFieldElement(layout_field))
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'DecimalField'){
                    return decimalFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'EmailField'){
                    return emailFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'ForeignKey'){
                    return lookupFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'EncryptedCharField'){
                    return encryptedCharFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'BigAutoField'){
                    return bigAutoFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'UUIDField'){
                    return uuidFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'AutoIdentifierNameField'){
                    return autoIdentifierNameFieldElement(layout_field)
                   }
                   else if(layout_field.ReferencedField_sys.Type_sys === 'FileField'){
                    return fileFieldElement(layout_field)
                   }
                   else{
                    return (<Box>TODO: {layout_field.ReferencedField_sys.Type_sys} </Box>)
                   }
                 })
               }
               </Grid>
               <Grid container spacing={1}>
               {layoutSection.layout_related_lists.map((this_list) => {
                 const layoutRelatedListUuid = this_list.Uuid_sys;
                 let thisRelatedRecords: RecordModel[] = [];
                 if(layoutRelatedListUuid in relatedRecords){
                   thisRelatedRecords = relatedRecords[layoutRelatedListUuid];
                 }

                   return (
                     <>
                        <Box sx={{width: "100%",
                                  border: 1,
                                  borderRadius: 5}}>
                           <RelatedListComponent
                              layoutRelatedList = {this_list}
                              columns = {this_list.columns.map((column) => column)}
                              records = {thisRelatedRecords}
                              loadMoreRecords={loadRelatedRecords}
                              selectRecord={selectRelatedRecord}
                           />
                        </Box>
                        <Box sx={{height: 10}}>
                        </Box>
                      </>
                    )
               })}

               </Grid>
              </AccordionDetails>
            </Accordion>

    </>
  );
  */

};
